export const commonDateEn = {
  day: "day",
  days: "days",
  month: "month",
  months: "months",
  week: "week",
  weeks: "weeks",
  year: "year",
  years: "years",
  lessThanOneMonth: "less than a month",
  lessThanOneDay: "less than a day",
  pastDistance: "{{value}} ago",
  futureDistance: "in {{value}}",
  startDate: "Start date",
  endDate: "End date",
  duration: "{{from}} - {{to}} ({{duration}})",
  dateRange: "{{from}} - {{to}}",
  dateRangeShort: "{{from}}-{{to}}",
};
